import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackSignUpStep1View = (): void => {
  trackingService.trackEvent(
    'SIGN_UP',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      route: '/cadastro',
      placement: '',
      surface: '',
      flow: 'cadastro usuário',
      step: 'dados acesso',
      element: '',
      action: 'view',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSignUpGoToLogin = (): void => {
  trackingService.trackEvent(
    'SIGN_IN',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      route: '',
      placement: 'main',
      surface: '',
      flow: 'login',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSignUpStep1Continue = (): void => {
  trackingService.trackEvent(
    'CONTINUE',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'dados acesso',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSignUpStep1Back = (): void => {
  trackingService.trackEvent(
    'BACK',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      route: '',
      placement: 'header',
      surface: '',
      flow: 'cadastro usuário',
      step: 'dados acesso',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSignUpStep2View = (): void => {
  trackingService.trackEvent(
    'SIGN_UP',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      route: '/cadastro',
      placement: '',
      surface: '',
      flow: 'cadastro usuário',
      step: 'dados profissionais',
      element: '',
      action: 'view',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSignUpStep2Continue = (): void => {
  trackingService.trackEvent(
    'CONTINUE',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'dados profissionais',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSignUpStep3View = (): void => {
  trackingService.trackEvent(
    'SIGN_UP',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      route: '/cadastro',
      placement: '',
      surface: '',
      flow: 'cadastro usuário',
      step: 'dados local atendimento',
      element: '',
      action: 'view',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSignUpStep3WhatsMyCep = (): void => {
  trackingService.trackEvent(
    'WHATS_MY_CEP',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'dados local atendimento',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSignUpStep3Continue = (): void => {
  trackingService.trackEvent(
    'CONTINUE',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'dados local atendimento',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSignUpStep4View = (): void => {
  trackingService.trackEvent(
    'SIGN_UP',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      route: '/cadastro',
      placement: '',
      surface: '',
      flow: 'cadastro usuário',
      step: 'senha',
      element: '',
      action: 'view',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSignUpStep4ShowPassword = (): void => {
  trackingService.trackEvent(
    'SHOW_PASSWORD',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'senha',
      element: 'icon button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSignUpStep4Continue = (): void => {
  trackingService.trackEvent(
    'CONTINUE',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'senha',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSignUpNavCredentialsClick = (): void => {
  trackingService.trackEvent(
    'CREDENTIALS',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'senha',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSignUpNavProfessionalInfoClick = (): void => {
  trackingService.trackEvent(
    'PROFESSIONAL_INFO',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'senha',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSignUpNavServiceLocationClick = (): void => {
  trackingService.trackEvent(
    'SERVICE_LOCATION',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'senha',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSignUpNavPasswordClick = (): void => {
  trackingService.trackEvent(
    'PASSWORD',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'senha',
      element: 'button',
      action: 'click',
      user_id: '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackNewSignUpView = (): void => {
  trackingService.trackEvent(
    'SIGN_UP',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      flow: 'cadastro usuário',
      step: 'credenciais',
      action: 'view',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackNewSignUpNavCredentialsClick = (): void => {
  trackingService.trackEvent(
    'CREDENTIALS',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'credenciais',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackNewSignUpProfessionalDataView = (): void => {
  trackingService.trackEvent(
    'SIGN_UP',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      flow: 'cadastro usuário',
      step: 'dados profissionais',
      action: 'view',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackNewSignUpNavProfessionalInfoClick = (): void => {
  trackingService.trackEvent(
    'PROFESSIONAL_INFO',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'dados profissionais',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackEmailConfirmedView = (): void => {
  trackingService.trackEvent(
    'EMAIL_SENT',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      flow: 'cadastro usuário',
      step: 'e-mail enviado',
      action: 'view',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackEmailConfirmedContinueClick = (): void => {
  trackingService.trackEvent(
    'CONTINUE',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      placement: 'footer',
      surface: '',
      flow: 'cadastro usuário',
      step: 'e-mail confirmado',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackEmailConfirmedGooglePlayClick = (): void => {
  trackingService.trackEvent(
    'GOOGLE_PLAY',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      placement: 'main',
      surface: '',
      flow: 'cadastro usuário',
      step: 'e-mail confirmado',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackEmailConfirmedAppStoreClick = (): void => {
  trackingService.trackEvent(
    'APP_STORE',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      placement: 'main',
      surface: '',
      flow: 'cadastro usuário',
      step: 'e-mail confirmado',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackNewSignUpContinueClick = (): void => {
  trackingService.trackEvent(
    'CONTINUE',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'credenciais',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackNewSignUpFinishClick = (): void => {
  trackingService.trackEvent(
    'CONTINUE',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'dados profissionais',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackConfirmEmailView = (): void => {
  trackingService.trackEvent(
    'EMAIL_SENT',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      flow: 'cadastro usuário',
      step: 'confirmação e-mail',
      action: 'view',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackConfirmEmailResendClick = (): void => {
  trackingService.trackEvent(
    'RESEND_EMAIL',
    PRODUCT_NAME,
    {
      page: 'cadastro usuário',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'confirmação e-mail',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
